import React, { useEffect, useState } from "react";
// import GeneralNavbar from '../../Header';
import GeneralNavbar from "../Header";
import Footer from "../Footer";
import "../css/presale.css";
import "../css/faq.css";
import Banner from "../Presale/Banner";
import { FaLinkedin } from "react-icons/fa";
import { Fade, Zoom } from "react-reveal";
// import AccordionBox from '../../Presale/Accordion';
import AccordionBox from "../Presale/Accordion";
import Community from "../../community";
import Header from "../../Header";

import { Container, Row, Col, Card, Button, Accordion } from "react-bootstrap";

const Faq = () => {
  return (
    <>
      <Header />

      <section className="faq_sec">
        <div className="faqbackImg-block">
          <img
            src="assets/images/faqbackImg.png"
            alt="faqbackImg"
            className="faqbackImg"
          />
          {/* <div> */}
          <h1 className="text-primary fw-bold fs-1">
            Frequently Asked Questions
          </h1>
          {/* </div> */}
        </div>
        <Container>
          <Row className="">
            <Col lg={12} className="py-5 mb-4">
              <div className="inner_block">
                <Row className="">
                

                  <Col lg={12} className="">
                    <div className="faq_accordion">
                      {/* <Accordion defaultActiveKey={['0']} alwaysOpen> */}
                      <Accordion defaultActiveKey={["0"]}>
                        <Accordion.Item
                          eventKey="0"
                          className="mb-3 px-4 active"
                        >
                          <Accordion.Header>
                            <div className="fs-4">
                              How to qualify for monthly passive income?
                            </div>
                          </Accordion.Header>
                          <Accordion.Body className="fs-5 pt-0">
                            <p className="text-black fs-5 mb-1">
                              To qualify for monthly passive income you have to
                              buy and stake INFI for 24 months
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1" className="mb-3 px-4">
                          <Accordion.Header>
                            <div className="fs-4">
                              Is there only a 24 month staking period?
                            </div>
                          </Accordion.Header>
                          <Accordion.Body className="fs-5 pt-0">
                            <p className="text-black fs-5 mb-1">
                              Yes. There is only one staking period, 24 months
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="3" className="mb-3 px-4">
                          <Accordion.Header>
                            <div className="fs-4">
                              What is the minimum and maximum INFI allocation I
                              can stake?
                            </div>
                          </Accordion.Header>
                          <Accordion.Body className="fs-5 pt-0">
                            <p className="text-black fs-5 mb-1">
                              The minimum INFI allocation to stake is 10 INFI
                              and the maximum is 12000 INFI.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="4" className="mb-3 px-4">
                          <Accordion.Header>
                            <div className="fs-4">
                              What is the maximum INFI staked allocation to
                              qualify for monthly passive incomes?
                            </div>
                          </Accordion.Header>
                          <Accordion.Body className="fs-5 pt-0">
                            <p className="text-black fs-5 mb-1">
                              After receiving passive income, the maximum INFI
                              allocation is 12,000 INFI. If you have more than
                              12,000 INFI, kindly use an additional wallet.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="5" className="mb-3 px-4">
                          <Accordion.Header>
                            <div className="fs-4">
                              How much is the monthly passive income?
                            </div>
                          </Accordion.Header>
                          <Accordion.Body className="fs-5 pt-0">
                            <p className="text-black fs-5 mb-1">
                            INFI acts as the core token, extending its value beyond traditional cryptocurrency. Holding INFI grants ownership rights in the parent company, Inverted Investment, along with its subsidiaries, and provides eligibility for a monthly passive income of 100%. This income is generated from the SbSe PFP, which is distributed in stable coins and Bitcoin from the SbSe BTC. INFI features a distinctive staking period of 24 months. The minimum staking amount for INFI is 10 tokens, while the maximum limit is 12,000 INFI per wallet. For amounts exceeding 12,000 INFI, we recommend using an additional wallet. The protocol will automatically calculate the profits.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="6" className="mb-3 px-4">
                          <Accordion.Header>
                            <div className="fs-4">
                              What is SbSe Funding Pool - SbSe PFP and SbSe BTC?
                            </div>
                          </Accordion.Header>
                          <Accordion.Body className="fs-5 pt-0">
                            <p className="text-black fs-5 mb-1">
                              The SbSe PFP reflects the profit generated by
                              Inverted Investment in USDT. The SbSe BTC reflects
                              the total amount in Bitcoin!
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="7" className="mb-3 px-4">
                          <Accordion.Header>
                            <div className="fs-4">
                              What are the SbSe Trading Rewards - SbSeTR?
                            </div>
                          </Accordion.Header>
                          <Accordion.Body className="fs-5 pt-0">
                            <p className="text-black fs-5 mb-1">
                              The SbSeTR reflects the passive income paid out in
                              USDT to the traders on a monthly basis
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="8" className="mb-3 px-4">
                          <Accordion.Header>
                            <div className="fs-4">
                              How do I get passive income as a trader?
                            </div>
                          </Accordion.Header>
                          <Accordion.Body className="fs-5 pt-0">
                            <p className="text-black fs-5 mb-1">
                              The SbSe Protocol will allocate locked INFI
                              allocation to traders based on their trading
                              activity. This locked allocation cannot be
                              accessed directly by traders. To begin earning
                              passive income, traders must accumulate a minimum
                              staking INFI allocation of 10 INFI. The whole
                              process is governed by SbSe Protocol
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="9" className="mb-3 px-4">
                          <Accordion.Header>
                            <div className="fs-4">
                              What is the Staked INFI TR Pool?
                            </div>
                          </Accordion.Header>
                          <Accordion.Body className="fs-5 pt-0">
                            <p className="text-black fs-5 mb-1">
                              The Staked INFI TR Pool - Staked INFI Trading
                              Reward Pool reflects the total amount of INFI
                              staked and automatically locked by the SbSe
                              Protocol
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="10" className="mb-3 px-4">
                          <Accordion.Header>
                            <div className="fs-4">
                              What is the Staked INFI Pool?
                            </div>
                          </Accordion.Header>
                          <Accordion.Body className="fs-5 pt-0">
                            <p className="text-black fs-5 mb-1">
                              Reflects the total staked INFI value. Please keep
                              in mind, that there are to staking pools: ● Staked
                              INFI Pool ● Staked INFI TR Pool
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="11" className="mb-3 px-4">
                          <Accordion.Header>
                            <div className="fs-4">
                              After trading, I acquired 100 INFI tokens and now
                              wish to boost my INFI holdings. Is it possible to
                              purchase from CDEX, resulting in two distinct
                              allocations?
                            </div>
                          </Accordion.Header>
                          <Accordion.Body className="fs-5 pt-0">
                            <p className="text-black fs-5 mb-1">
                              The INFI allocation earned from trading activities
                              will be stored in the Staked INFI TR Pool and will
                              not be accessible by the trader. Any extra INFI
                              allocation purchased and staked for 24 months will
                              be placed in a distinct staking pool, into the
                              Staked INFI Pool. In this case traders will only
                              have access to migrate and transfer the INFI
                              allocation locked in the Staked INFI TR Pool to
                              the Staked INFI Pool.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="12" className="mb-3 px-4">
                          <Accordion.Header>
                            <div className="fs-4">What is SbSe Token Pool?</div>
                          </Accordion.Header>
                          <Accordion.Body className="fs-5 pt-0">
                            <p className="text-black fs-5 mb-1">
                              SbSe Token Pool reflects to total amount of tokens
                              accumulated by the SbSe Protocol if trader in the
                              sell process choose “ Send to SbSe Token Pool “
                              instead of “burn”
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="13" className="mb-3 px-4">
                          <Accordion.Header>
                            <div className="fs-4">
                              What is Special Liquidity Management- SpecialLM?
                            </div>
                          </Accordion.Header>
                          <Accordion.Body className="fs-5 pt-0">
                            <p className="text-black fs-5 mb-1">
                              The Special Liquidity Management system provides a
                              48- hour compensation plan for traders in case of
                              any problems or scams arising from a project.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="14" className="mb-3 px-4">
                          <Accordion.Header>
                            <div className="fs-4">
                              Is INFI MultiChain CDEX offering KYC or Audit for
                              startups projects?
                            </div>
                          </Accordion.Header>
                          <Accordion.Body className="fs-5 pt-0">
                            <p className="text-black fs-5 mb-1">
                              Yes we do! However while KYC and audits are
                              important aspects, they're not always enough to
                              combat fraudulent activities. That's why we've
                              developed a unique Liquidity Management system
                              that offers a 48-hour compensation scheme in case
                              of any issues. Additionally, we work closely with
                              trusted digital cybersecurity firms to ensure that
                              our platform is secure. Start-up projects must
                              embrace Special Liquidity management as a
                              prerequisite for listing on INFI CDEX.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="15" className="mb-3 px-4">
                          <Accordion.Header>
                            <div className="fs-4">
                              Who will have access to SpecialLM activity? Who is
                              supervising the trading activity on INFI CDEX and
                              what is the SmartWatch account?
                            </div>
                          </Accordion.Header>
                          <Accordion.Body className="fs-5 pt-0">
                            <p className="text-black fs-5 mb-1">
                              The trading activity will be overseen by INFI
                              Admin, cybersecurity, KYC, and audit companies. A
                              24-hour SmartWatch account will monitor the
                              trading operations with experts who have access to
                              the INFI CDEX Platform. This setup allows for
                              immediate action in case of any problems.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="16" className="mb-3 px-4">
                          <Accordion.Header>
                            <div className="fs-4">
                              Are there any fees associated with listing
                              projects?
                            </div>
                          </Accordion.Header>
                          <Accordion.Body className="fs-5 pt-0">
                            <p className="text-black fs-5 mb-1">
                              The listing fee on INFI CDEX is absolutely free!
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                    <div className="text-center mt-4">
                      {/* <Button variant="custombtn4" className='text-uppercase px-5 fw-bolder' style={{ letterSpacing: "1.1px" }}>Load More</Button> */}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Community />

      <Footer />
    </>
  );
};

export default Faq;
